module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABLElEQVQ4T92Tv0rDcBDHv9+g0thapHVwNOAD9AEsWGhHQZOH0CgOgm+hoyY4OTqlHXRroUJ9gD6AoIOjFamtP9GSk4Qq5kelWVy87e6+fO4Pd4RmjvdWBaWpx2NfWAt2M62fOerCjeP+0lx2dluAGU04eh9+nF0e5h8TcdtTFySWJ1acEgwFD7R9dU5gRURKJBfTgETkmWRXgPvvERxftQGspwEAuA5csxJp/wgg7PakXy4YC3dRlafwxSoy3wGlNO5wagexwPZVDKi7pqWN+P8BIt2eDMoFIzde4sAqMtcB+fsSbV81CVTT3IEArbpr1pJ34CkfxE4aAMCTwM3sJwBbp69rJNtk8ol0oAhGIlJp7M3fJACR43jDTcA4ArE6+Z1xGzI8aLjZq6/8J0QqpBG+Pz+JAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sources/del-1.png
// module id = /orE
// module chunks = 96